<template>
    <div class="table">
        <div class="crumbs">
            <el-breadcrumb separator="/">
                <el-breadcrumb-item>{{menuName}}->{{title}}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <el-tabs v-model="activeName" style="margin-top:15px;" type="border-card" @tab-click="handleClick">
            <el-tab-pane label="按考勤名查看" name="second">
                <child2></child2>    
            </el-tab-pane>
            <el-tab-pane label="按学生查看" name="third">
                <child3></child3>    
            </el-tab-pane>
            <el-tab-pane label="学生考勤明细" name="first">
                <child1></child1>
            </el-tab-pane>
        </el-tabs>
    </div>
</template>

<script>
    import student from './Student.vue'
    import studentCatalogue from './StudentCatalogue.vue'
    import studentAttendance from './StudentAttendance.vue'

    export default {
        name:"StudentMain",
        components:{
            child1:student,
            child2:studentCatalogue,
            child3:studentAttendance
        },
        data() {
            return {
                menuName:"",
                //默认第一个选项卡
                activeName: "second",
                title:"按考勤名查看"
            }
        },
        created:function () {
            this.menuName = sessionStorage.getItem("selectMenuItem_key");
        },
        methods:{
            handleClick(tab) {
                if(tab.name == "first") {
                    this.title="学生考勤";
                } else if(tab.name == "second") {
                    this.title="按考勤名查看";
                } else if(tab.name == "third") {
                    this.title="按学生查看";
                }
            }
        }
    }

</script>

<style scoped>
</style>


// WEBPACK FOOTER //
// src/components/page/count/student/StudentMain.vue